export enum SkynityCookie {
  AuthToken = 'AuthToken',
  SelectedGameServer = 'SeletedGameServer',
}
